<template>
  <!-- CPAP 処方中止 -->
  <div id="CpapCancelDetail">
    <div :id="getContainerType()">
      <div class="labelTitle lable">CPAP 処方中止</div>
      <div class="button-area"><b-button class="backButton is-primary" @click="back">戻る</b-button></div>
      <div id="item-contens">
        <div class="card-content margin-top">
          <table>
            <tr>
              <th style="vertical-align:top;">中止理由コメント</th>
              <td colspan="2">
                <textarea maxlength="255" style="resize:vertical;max-width:100%;height:60px;" v-model="data.cancelReasonText"></textarea>
              </td>
            </tr>
            <tr>
              <th>機器回収先<span class="require"/></th>
              <td colspan="2">
                <div class="block">
                  <b-radio class="td_radio" name="機器回収先" v-model="data.returnSource" :native-value=0 @input="changeDelivaryTarget(data.returnSource)">患者宅</b-radio>
                  <b-radio class="td_radio" name="機器回収先" v-model="data.returnSource" :native-value=1 @input="changeDelivaryTarget(data.returnSource)">医療機関</b-radio>
                </div>
              </td>
            </tr>
            <tr><th></th>
              <td style="vertical-align: middle;"><b-checkbox class="cstmCheckBox" value="true" v-model="data.deliveryOther" @input="changeDelivaryTarget(data.returnSource)">回収先住所を変更する</b-checkbox></td>
              <td><span v-if="!isHospital && !isDealer" style="font-size:11px; color:red; text-align: left; display: inline-block;">※チェックをした場合、こちらの住所は得意先コードの住所（患者・医療機関）には反映されません。</br>※支店・営業所の住所は入力しないでください。</span></td>
            </tr>
          <template v-if="data.deliveryOther">
            <tr>
              <th>
                郵便番号<span class="require"/>
              </th>
              <td colspan="2">
                <input
                  id="deliveryPostcode"
                  style="width: 250px;"
                  v-model="data.deliveryPostcode"
                  class="1"
                  :class="{'border-red': invalidPostcode}"
                  name="郵便番号"
                  validate="required|numeric|zip"
                  maxlength="7"
                  :placeholder="postcodePlaceholder"
                  @blur="onZipBlur(data.deliveryPostcode, 'digitErrorDeliveryPostcode')"
                  @paste="onPaste"
                />
                <b-button
                  style="margin-left: 10px; width: 150px; height: 27px;"
                  v-on:click="addressSearch(data.deliveryPostcode)">自動入力
                </b-button>
                <div v-show="invalidPostcode" class="text-red">{{ invalidNumberMessage }}</div>
                <div v-show="digitErrorDeliveryPostcode" class="text-red">{{ digitErrorZipMessage }}</div>
              </td>
            </tr>
            <tr><th>住所（都道府県、市町村区）<span class="require" style="margin-left:-8px;"/></th><td colspan="2"><input type="text" v-model="data.deliveryAddress" class="1" name="住所（都道府県、市町村区）" validate="required" maxlength="280"/></td></tr>
            <tr><th>住所（それ以降の住所）<span class="require"/></th><td colspan="2"><input type="text" v-model="data.deliveryHouseNumber" class="1" name="住所（それ以降の住所）" validate="required" maxlength="256" ref="deliveryHouseNumber"/></td></tr>
            <tr><th>住所（建物名、部屋番号）</th><td colspan="2"><input type="text" v-model="data.deliveryBuilding" maxlength="256"/></td></tr>
            <tr><th>回収先名称<span class="require"/></th><td colspan="2"><input type="text" v-model="data.deliveryDestination" maxlength="100" class="1" name="回収先名称" validate="required"/></td></tr>
            <tr>
              <th>
                連絡先（電話番号）<span class="require"/>
              </th>
              <td colspan="2">
                <input
                  type="text"
                  v-model="data.deliveryPhoneNumber"
                  maxlength="11"
                  class="1"
                  :class="{'border-red': invalidPhoneNumber}"
                  name="連絡先(電話番号)"
                  validate="required|numeric"
                  :placeholder="phonePlaceholder"
                />
                <div v-show="invalidPhoneNumber" class="text-red">{{ invalidNumberMessage }}</div>
              </td>
            </tr>
          </template>
          <template v-else>
            <tr>
              <th>
                郵便番号<span class="require"/>
              </th>
              <td colspan="2">
                <input
                  id="deliveryPostcode"
                  style="width: 250px;"
                  v-model="data.deliveryPostcode"
                  class="1"
                  name="郵便番号"
                  validate="required|numeric"
                  maxlength="7"
                  disabled
                />
              </td>
            </tr>
            <tr><th>住所（都道府県、市町村区）<span class="require" style="margin-left:-8px;"/></th><td colspan="2"><input type="text" v-model="data.deliveryAddress" class="1" name="住所（都道府県、市町村区）" validate="required" maxlength="280" disabled/></td></tr>
            <tr><th>住所（それ以降の住所）<span class="require"/></th><td colspan="2"><input type="text" v-model="data.deliveryHouseNumber" class="1" name="住所（それ以降の住所）" validate="required" maxlength="256" disabled/></td></tr>
            <tr><th>住所（建物名、部屋番号）</th><td colspan="2"><input type="text" v-model="data.deliveryBuilding" maxlength="256" disabled/></td></tr>
            <tr><th>回収先名称<span class="require"/></th><td colspan="2"><input type="text" v-model="data.deliveryDestination" maxlength="100" class="1" name="回収先名称" validate="required" disabled/></td></tr>
            <tr>
              <th>
                連絡先（電話番号）<span class="require"/>
              </th>
              <td colspan="2">
                <input
                  type="text"
                  v-model="data.deliveryPhoneNumber"
                  maxlength="11"
                  class="1"
                  name="電話番号"
                  validate="required|numeric"
                  disabled
                />
              </td>
            </tr>
          </template>
          </table>
        </div>
        <cpapRequestDetail :data="showDetailTargetData" :innerUser="!isHospital && !isDealer" :showRequestInfo="!isHospital && !isDealer" :progress="showDetailTargetData.applicationType" :isEdit="false" v-on:back="back" :deliveryHidden="true" :commentFlg="true" :cancelResume="true"/>
        <div class="button-area">
          <b-button class="receptionistButton is-primary" @click="cancel">申込む</b-button>
        </div>
        <div class="button-area">
          <b-button class="backButton is-primary" @click="back">戻る</b-button>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import {
  role,
  invalidNumberMessage,
  postcodePlaceholder,
  phonePlaceholder,
  cpapChoicesType,
  digitErrorZipMessage,
} from "@/components/mock/base/const.js";
import CpapRequestDetail from "@/components/mock/common/CpapRequestDetail";

export default {
  name: "CpapCancelDetail",
  methods: {
    getContainerType: function(){
      let type = "container";
      if(this.isHospital || this.isDealer){
        type = "container-center"
      }
      return type;
    },
    back: function() {
      if(this.compleateFlg && this.backRoutParams) {this.backRoutParams.pdfDisplay = true;}
      if(this.backRoutName){
        this.$router.push({
          name: this.backRoutName,
          params: this.backRoutParams,
          isEscrow: this.$route.params["isEscrow"],
        });
      }else{
        this.$router.go(-1);
      }
    },
    addressSearch: function(val){
      // 検索対象の郵便番号を設定
      this.searchTargetPostCode = val
      this.searchTargetAddress = null
      this.postCodeSearch().then(result=>{
        if (!this.searchTargetAddress) return;
        this.data.deliveryAddress = this.searchTargetAddress.prefecture + " " + this.searchTargetAddress.city + " " + this.searchTargetAddress.town
        this.data.deliveryHouseNumber = "";
        this.data.deliveryBuilding = "";

        // QA476 住所設定後フォーカスを移動する
        this.focusMove("deliveryHouseNumber");
        this.digitErrorDeliveryPostcode = false;
      })
    },
    postCodeSearch: function(){
      var excuteApi = this.getAddressFromPostCodePOST;
      var successCallBack = this.getAddressFromPostCodePOSTSuccess;
      var errorCallBack = this.getAddressFromPostCodePOSTError;
      // WebAPI Call
      return this.apiCall(excuteApi, successCallBack, errorCallBack);
    },
    getAddressFromPostCodePOST: function(client) {
      return client.apis.apiCommon.getAddressFromPostCodePOST({
        body:{
          postCode:this.searchTargetPostCode
        }
      });
    },
    getAddressFromPostCodePOSTSuccess: function(result) {
      this.searchTargetAddress = result.obj
      this.searchTargetPostCode = ""
    },
    getAddressFromPostCodePOSTError: function(result) {
      this.searchTargetPostCode = ""
    },
    cancel: function() {
      // バリデーションチェック
      if(!this.showDetailTargetData.existingFlag){
        var elements = document.getElementsByClassName(1)
        var result = this.selfMadeValidation(elements)

        if(result.isError){
          this.showErrorMessage(result.msg)
          return
        }
      }
      var messsage = "処方中止を申込みます。<br/>内容を確認して「OK」ボタンを押してください。"
      this.$dialog.confirm({
        title: "申込み確認",
        message: messsage,
        cancelText: "キャンセル",
        onConfirm: async () => {
          this.compleateFlg = true;
          var excuteApi = this.setCpapCancelPrescriptionRequestPOST;
          var successCallBack = this.setCpapCancelPrescriptionRequestPOSTSuccess;
          var errorCallBack = this.setCpapCancelPrescriptionRequestPOSTError;
          // WebAPI Call
          await this.apiCall(excuteApi, successCallBack, errorCallBack)
          if(this.compleateFlg){
            this.back();
          }
        }
      });
    },
    setCpapCancelPrescriptionRequestPOST: function(client) {

      var obj = JSON.parse(JSON.stringify(this.data));
      obj.receiptNumber = this.showDetailTargetData.receiptNumber
      obj.contractEndDate = obj.contractEndDate ? obj.contractEndDate.replace(/-/g, "/") : ""
      obj.temp = this.temp

      return client.apis.externalCpap.setCpapCancelPrescriptionRequestPOST({
        body:obj
      });
    },
    setCpapCancelPrescriptionRequestPOSTSuccess: function(result) {
      // 成功メッセージ表示
      this.showSuccess(result);
      this.compleateFlg = true
    },
    setCpapCancelPrescriptionRequestPOSTError: function(result) {
      // エラーメッセージ表示
      this.showErrorMessage(result);
    },
    getCpapChoicesList: async function() {
      this.cancelCodeMaster = this.getCpapChoiceList(cpapChoicesType.cancellReason,false);
      this.billedCurrentMonth = this.getCpapChoiceList(cpapChoicesType.billedCurrentMonth,false);
    },
    changeDelivaryTarget: function(returnSource) {
      if (returnSource == 0) {
        this.data.deliveryPostcode = this.data.patient.zip
        this.data.deliveryAddress = this.data.patient.address
        this.data.deliveryHouseNumber = this.data.patient.address1
        this.data.deliveryBuilding = this.data.patient.address2
        this.data.deliveryDestination = this.data.patient.patientFamilyName + " " + this.data.patient.patientFirstName
        if (this.data.patient.mobilePhone) {
          this.data.deliveryPhoneNumber = this.data.patient.mobilePhone
        } else {
          this.data.deliveryPhoneNumber = this.data.patient.phoneNumber
        }
      } else {
        this.data.deliveryPostcode = this.data.zip
        this.data.deliveryAddress = this.data.address
        this.data.deliveryHouseNumber = this.data.address1
        this.data.deliveryBuilding = this.data.address2
        this.data.deliveryDestination = this.data.receiverName
        this.data.deliveryPhoneNumber = this.data.phoneNumber
      }
      this.isChangeDelivaryTarget = true;
    },
    /**
     * QA476 郵便番号からフォーカスが外れたら桁数に応じて桁数判定フラグを設定する
     * @param zipCode 郵便番号
     * @param flagName 桁数判定フラグ
     */
    onZipBlur(zipCode, flagName) {
      this[flagName] = zipCode.length < 7;
    },
    /**
     * QA476 引数に指定した項目の末尾にフォーカスを移動する
     * @param refName フォーカスをあてる項目定義
     */
    focusMove(refName) {
      this.$nextTick(() => {
        const element = this.$refs[refName];
        if (element) {
          element.focus();
          const length = element.value.length;
          element.setSelectionRange(length, length);
        }
      })
    },
    onPaste() {
      this.isInitial = false;
      this.isChangeDelivaryTarget = false;
    }
  },
  data() {
    // 仮持出申込み判定
    var temp = false;
    if(this.$route.params["temp"]){
      temp = this.$route.params["temp"];
    }
    var branchOfficeMaster= this.getSalesOfficeMaster();
    var cpapCodeMaster = this.getCpapCodeMaster();
    var backRoutName = this.$route.params["name"];
    var backRoutParams = this.$route.params;
    var showDetailTargetData = this.$route.params["selectedData"];
    showDetailTargetData.instructionDate = this.yyyy_hyp_MM_hyp_dd(new Date())
    var userInfo = JSON.parse(sessionStorage.getItem("userInfo"));
    var roleId = userInfo.roleId;
    var userId = userInfo.id;
    var isHospital = roleId == role.role_hospital;
    var isDealer = roleId == role.role_dealer;
    var isSalesOffice = roleId == role.role_salesOffice;
    var isHonsha = roleId == role.role_headOffice;
    var isAdmin = roleId == role.role_admin;
    var officeCode = userInfo.salesOfficeCode
    var returnSource =  showDetailTargetData.delivaryTarget == 'hospital' ? 1 : 0
    var data = {
      cancelReasonCode:"",
      cancelReasonText:"",
      collectionDestination:1,
      returnSource:returnSource,
      contractEndDate:showDetailTargetData.contractEndDate,
      contractEndMin:showDetailTargetData.contractEndMin,
      existingFlag:showDetailTargetData.existingFlag,
      patient:showDetailTargetData.patient,
      zip:showDetailTargetData.zip,
      address:showDetailTargetData.address,
      address1:showDetailTargetData.address1,
      address2:showDetailTargetData.address2,
      receiverName:showDetailTargetData.receiverName,
      phoneNumber:showDetailTargetData.phoneNumber,
      deliveryPostcode:"",
      deliveryAddress:"",
      deliveryHouseNumber:"",
      deliveryBuilding:"",
      deliveryDestination:"",
      deliveryPhoneNumber:"",
      deliveryOther:false,
      medicalInstitutionCode:showDetailTargetData.medicalInstitutionCode,
      medicalInstitutionName:showDetailTargetData.medicalInstitutionName,
    }
    // QA316 納品先情報は引き継がない
    if (showDetailTargetData.delivaryTarget== 'home') {
      data.deliveryPostcode = showDetailTargetData.patient.zip
      data.deliveryAddress = showDetailTargetData.patient.address
      data.deliveryHouseNumber = showDetailTargetData.patient.address1
      data.deliveryBuilding = showDetailTargetData.patient.address2
      data.deliveryDestination = showDetailTargetData.patient.patientFamilyName + " " + showDetailTargetData.patient.patientFirstName
      if (data.patient.mobilePhone) {
        data.deliveryPhoneNumber = showDetailTargetData.patient.mobilePhone
      } else {
        data.deliveryPhoneNumber = showDetailTargetData.patient.phoneNumber
      }
      data.deliveryOther = false
    } else {
      data.deliveryPostcode = showDetailTargetData.zip
      data.deliveryAddress = showDetailTargetData.address
      data.deliveryHouseNumber = showDetailTargetData.address1
      data.deliveryBuilding = showDetailTargetData.address2
      data.deliveryDestination = showDetailTargetData.receiverName
      data.deliveryPhoneNumber = showDetailTargetData.phoneNumber
      data.deliveryOther = false
    }
    return {
      cpapCodeMaster,
      backRoutName,
      backRoutParams,
      showDetailTargetData,
      role: role,
      roleId: roleId,
      userId: userId,
      isHospital: isHospital,
      isDealer: isDealer,
      isSalesOffice: isSalesOffice,
      isHonsha: isHonsha,
      isAdmin: isAdmin,
      data,
      searchTargetPostCode:"",
      searchTargetAddress:null,
      cancelCodeMaster:[],
      billedCurrentMonth:[],
      temp,
      officeCode,
      branchOfficeMaster,
      invalidPostcode: false,
      invalidPhoneNumber: false,
      // template message
      invalidNumberMessage,
      postcodePlaceholder,
      phonePlaceholder,
      isEscrow: "",
      digitErrorZipMessage,
      digitErrorDeliveryPostcode:false,
      isInitial:true,
      isChangeDelivaryTarget:false,
    };
  },
  filters: {},
  components: {
    cpapRequestDetail:CpapRequestDetail
  },
  mounted: function() {
    if(!this.isHospital && !this.isDealer){
      // 内部ユーザーのみCPAP汎用コードマスタ取得
      this.getCpapChoicesList();
    }

    this.invalidPostcode = isNaN(Number(this.data.deliveryPostcode));
    this.invalidPhoneNumber = isNaN(Number(this.data.deliveryPhoneNumber));
  },
  watch: {
    "data.deliveryPostcode"(newValue) {
      this.invalidPostcode = isNaN(Number(newValue));
      // 初期表示時、機器回収先が変更されたタイミングは郵便番号検索しない
      if (this.isInitial || this.isChangeDelivaryTarget) {
        this.isInitial = false;
        this.isChangeDelivaryTarget = false;
        return
      }
      if (!this.invalidPostcode && newValue.length === 7) {
        this.addressSearch(newValue);
      }
    },
    "data.deliveryPhoneNumber"(newValue) {
      this.invalidPhoneNumber = isNaN(Number(newValue));
    },
  },
};
</script>
<style lang="scss" scoped>
table.flowTable,
table.flowTable tr,
table.flowTable td {
  border: 1px solid;
  padding: 0px;
  vertical-align: middle;
}
table.flowTable td {
  width: 40px;
  text-align: center;
}
a {
  text-decoration: underline;
}
.historyTable-area {
    max-height:500px;
    overflow-x: hidden;
    overflow-y: scroll;
}
.historyTable {
    width: 1150px !important;
}
.historyTable .date {
    width:120px !important;
}
.historyTable .operation {
    width:80px !important;
}
.historyTable .detail {
    width:500px !important;
}
.historyTable .operator{
    width:250px !important;
}
</style>



// WEBPACK FOOTER //
// src/components/mock/guest/cpap/CpapCancelDetail.vue